import { Api } from '@monorepo/shared/apiClient';
import {
  DocumentFoldersCacheEvents,
  invalidateDocumentFoldersCache,
} from '@monorepo/shared/cacheRegisters/documents/documentFoldersCacheRegister';
import { DocumentFolderResponse } from 'mapistry-shared';
import { MutationConfig, useMutation } from 'react-query';

type UseRenameDocumentFolderParams = {
  config?: MutationConfig<DocumentFolderResponse, Api.ErrorResponse>;
};

export const useRenameDocumentFolder = (
  params?: UseRenameDocumentFolderParams,
) =>
  useMutation(Api.renameDocumentFolder, {
    ...params?.config,
    onSuccess: (data, vars) => {
      invalidateDocumentFoldersCache(DocumentFoldersCacheEvents.UPDATE, {
        organizationId: vars.organizationId,
      });
      return params?.config?.onSuccess?.(data, vars);
    },
  });
